import React, { Component } from 'react';

import PHP from './syntax/PHP';
import HTML from './syntax/HTML';

class Syntax extends Component {
  render() {
    let preview;

    const editorStyles = {
      container: {
        backgroundColor: this.props.theme.background,
        color: this.props.theme.foreground
      }
    };

    const styles = {
      keyword: {color: this.props.theme.first},
      comment: {color: this.props.theme.comment},
      function: {color: this.props.theme.second},
      functionName: {color: this.props.theme.third},
      string: {color: this.props.theme.string},
      operators: {color: this.props.theme.fourth},
      foreground: {color: this.props.theme.foreground},
  };

    switch (this.props.current) {
      case 'php': {
        preview = <PHP styles={styles} />
        break;
      }
      case 'html': {
        preview = <HTML styles={styles} />
        break;
      }
      default: {
        preview = <div>No language.</div>
      }
    }

    return (
      <div style={editorStyles.container} className="syntax">
        <div className="syntax__edit-pane">
          {preview}
        </div>
      </div>
    );
  }
}

export default Syntax;



// WEBPACK FOOTER //
// ./src/components/Syntax.js